import { createStore, applyMiddleware } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootReducer from './reducers';
import thunk from 'redux-thunk';

export default function configureStore(initialState) {
	//preparing persist config. whitelisting reducers to be stored in persist memory
	const persistConfig = {
		key: 'root',
		storage,
		whitelist: ['user'],
	};
	const persistedReducer = persistReducer(persistConfig, rootReducer);
	const store = createStore(persistedReducer, initialState, applyMiddleware(thunk));
	return store;
}
